import { unref } from 'vue';
import type { RouteLocationNormalized, RouteRecordNormalized } from 'vue-router';
import type { App, Plugin } from 'vue';
import {StorageUtils, isObject, GoingNewUtils, getUrlParams} from 'xmgoing-utils';
import dayjs from "dayjs";
import { getMenuObjByKey } from '@/utils/buryingPoint';

export const noop = () => {};

export function getCurYmStr(){
  let curM:any=parseFloat(dayjs().startOf('month').format('MM'));
  if(parseFloat(curM)<10){
    curM = "0"+curM;
  }
  const curYM=dayjs().startOf('year').format('YYYY')+curM;
  return curYM;
}
/**
 * 设置值
 * @param defProps
 * @param sectionConfig
 */
export function setPropsValues(defProps,sectionConfig){
  if(sectionConfig==null){
    return;
  }
  Object.keys(unref(defProps)).forEach((propName)=>{
    unref(sectionConfig)[propName]=defProps[propName];
  })
}
export function getNumberVal(num:any) {
  if(num==null||num===""){
    return 0;
  }
  if (isNaN(parseFloat(num))) {
    return 0;
  }
  return parseFloat(num)
}
export function toNumber(priceSty:string|number){
  priceSty=(priceSty+'').replace(/,/g,"");
  return priceSty;
}
/**
 * 数字转化成带千分符的金额,并且保留四位小数
 * @param num 需要转化的数字
 */
export function formatMoney(number: number,fixNum=2): string {
  number = toNumber(number)
  // 验证输入是否为数值
  if (isNaN(parseFloat(number))) {
    return '';
  }

  // 判断是否为负数
  const isNegative = number < 0;

  // 取绝对值并转换为字符串
  const absoluteNumber = Math.abs(number).toFixed(fixNum);

  // 判断是否为整数
  const isInteger = Number.isInteger(number);

  // 获取整数部分和小数部分
  const [integerPart, decimalPart] = absoluteNumber.split('.');

  // 添加千分符
  let formattedNumber = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  // 判断是否为小数，若是小数则添加小数部分
  if (!isInteger) {
    formattedNumber += `.${decimalPart}`;
  }

  // 添加负号
  if (isNegative) {
    formattedNumber = `-${formattedNumber}`;
  }

  return formattedNumber;
}

/**
 * @description:  Set ui mount node
 */
export function getPopupContainer(node?: HTMLElement): HTMLElement {
  return (node?.parentNode as HTMLElement) ?? document.body;
}


/**
 * 获取2位字符串
 * @param value
 */
export function fixedTwoNumber(value:number){
  var value:any=Math.round(parseFloat(value)*100)/100;
  var xsd=value.toString().split(".");
  console.log(value)
  if(xsd.length==1){
    value=value.toString()+".00";
    return value;
  }
  if(xsd.length>1){
    if(xsd[1].length<2){
      value=value.toString()+"0";
    }
    return value;
  }
}

export function fixedThreeNumber(value:number){
  var value:any=Math.round(parseFloat(value)*1000)/1000;
  var xsd=value.toString().split(".");
  console.log(value)
  if(xsd.length==1){
    value=value.toString()+".000";
    return value;
  }
  if(xsd.length>1){
    if(xsd[1].length<3){
      value=value.toString()+"0";
    }
    return value;
  }
}

export function fixedOneNumber(value:number){
  var value:any=Math.round(parseFloat(value)*10)/10;
  var xsd=value.toString().split(".");
  console.log(value)
  if(xsd.length==1){
    value=value.toString()+".0";
    return value;
  }
  if(xsd.length>1){
    if(xsd[1].length<3){
      value=value.toString()+"0";
    }
    return value;
  }
}

/**
 * 初始化默认属性
 * @param defProps
 * @param sectionConfig
 */
export function initPropDefValues(defProps,sectionConfig){
  Object.keys(defProps).forEach((propName)=>{
    if(unref(sectionConfig)[propName]==undefined||unref(sectionConfig)[propName]===""){
      unref(sectionConfig)[propName]=defProps[propName];
    }
  })
}

export function getSelItem(key,items,targetObj){
  if(unref(items)&&Array.isArray(unref(items))){
    // 侧栏多入口消歧：按唯一菜单 id / curMenuEntryId，禁止同 path 取第一个
    getMenuObjByKey(unref(items), key, targetObj);
  }
}


export function loadSystem(){
  const sessionId = getUrlParams('sessionId', true);
  //如果存在sessionId 则存到缓存中去
  if (sessionId) {
    StorageUtils.addSessionItem('sessionId', sessionId);
  }
}
export function getElKey(){
  return 'key'+GoingNewUtils.getUUChar(12);
}
/**
 * 通过message刷新父界面
 */
export function flushParentPageByMessage(){
  try{
    window.parent?.postMessage(
      { action: "flushPortalList", namespace: "xm" },
      "*"
    );
    window.opener?.postMessage(
      { action: "flushPortalList", namespace: "xm" },
      "*"
    );
  }catch (e){

  }
}

/**
 * 获取路径最后的单词
 * @param path
 */
export function getLastPath(path){
  const pathAry=path.split("/");
  return pathAry[pathAry.length-1];
}

/**
 * Add the object as a parameter to the URL
 * @param baseUrl url
 * @param obj
 * @returns {string}
 * eg:
 *  let obj = {a: '3', b: '4'}
 *  setObjToUrlParams('www.baidu.com', obj)
 *  ==>www.baidu.com?a=3&b=4
 */
export function setObjToUrlParams(baseUrl: string, obj: any): string {
  let parameters = '';
  for (const key in obj) {
    parameters += key + '=' + encodeURIComponent(obj[key]) + '&';
  }
  parameters = parameters.replace(/&$/, '');
  return /\?$/.test(baseUrl) ? baseUrl + parameters : baseUrl.replace(/\/?$/, '?') + parameters;
}

// 深度合并
export function deepMerge<T = any>(src: any = {}, target: any = {}): T {
  let key: string;
  for (key in target) {
    src[key] = isObject(src[key]) ? deepMerge(src[key], target[key]) : (src[key] = target[key]);
  }
  return src;
}

export function openWindow(
  url: string,
  opt?: { target?: TargetContext | string; noopener?: boolean; noreferrer?: boolean },
) {
  const { target = '__blank', noopener = true, noreferrer = true } = opt || {};
  const feature: string[] = [];

  noopener && feature.push('noopener=yes');
  noreferrer && feature.push('noreferrer=yes');
  if(url.indexOf("?")>0){
    url=url+`&loginUserType=user&sessionId=`+(getUrlParams("sessionId",true)||StorageUtils.getSessionItem('sessionId'));
  }else{
    url=url+`?loginUserType=user&sessionId=`+(getUrlParams("sessionId",true)||StorageUtils.getSessionItem('sessionId'));
  }
  window.open(url, target, feature.join(','));
}

// dynamic use hook props
export function getDynamicProps<T, U>(props: T): Partial<U> {
  const ret: Recordable = {};

  // @ts-ignore
  Object.keys(props).map((key) => {
    ret[key] = unref((props as Recordable)[key]);
  });

  return ret as Partial<U>;
}

export function getRawRoute(route: RouteLocationNormalized): RouteLocationNormalized {
  if (!route) return route;
  const { matched, ...opt } = route;
  return {
    ...opt,
    matched: (matched
      ? matched.map((item) => ({
          meta: item.meta,
          name: item.name,
          path: item.path,
        }))
      : undefined) as RouteRecordNormalized[],
  };
}

export const withInstall = <T>(component: T, alias?: string) => {
  const comp = component as any;
  comp.install = (app: App) => {
    app.component(comp.name || comp.displayName, component);
    if (alias) {
      app.config.globalProperties[alias] = component;
    }
  };
  return component as T & Plugin;
};
